import { gql } from '@apollo/client';

export const CREATE_HIERARCHY_UNIT_MUTATION = gql`
  mutation SalesWebCreateUnit($input: CreateUnitInput) {
    createUnit(input: $input) {
      id
      name
    }
  }
`;
